// Restricting action Buttons to stick to bottom of the card | Grid view only - V
// Concerned CSS added to custom.css
document.addEventListener("DOMContentLoaded", function() {
  const params = new URLSearchParams(window.location.search);
  const view = params.get("grid_list");

  document.body.classList.remove("view-grid", "view-list"); // reset first
  if (view === "grid-view") {
    document.body.classList.add("view-grid");
  } else if (view === "list-view") {
    document.body.classList.add("view-list");
  } else if(view == null){  
    // default case for the first load when no url parameter is passed
    document.body.classList.add("view-grid");
  }
});

// Custom ATC button on product page (Top) - V
document.addEventListener('DOMContentLoaded', function() {
  var customBtn = document.querySelector('[data-add-to-cart-custom]');
  var defaultBtn = document.querySelector('div.product-form--atc div.product-form__action-wrapper button[type="submit"]');
  
  // Show same button text
  var defaultBtnLabelText = document.querySelector('div.product-form--atc div.product-form__action-wrapper button[type="submit"] span.atc-button--text').innerHTML.trim();
  // console.log("defaultBtnLabelText: " + defaultBtnLabelText);
  document.querySelector('[data-add-to-cart-custom] span.atc-button--text').value = defaultBtnLabelText;

  if((defaultBtnLabelText.toLowerCase() == "add to cart") || (defaultBtnLabelText.toLowerCase() == "pre-order")){
    if (customBtn && defaultBtn) {
      customBtn.addEventListener('click', function() {

        // Add loading state + disabled state
        customBtn.classList.add('loading');
        customBtn.disabled = true;

        defaultBtn.click(); // triggers default add-to-cart logic

        // Manual timeout for loader in case the submission fails
        setTimeout(function() {
          customBtn.classList.remove('loading');
          customBtn.disabled = false;
        }, 8000);
      });
    }
  } else if(defaultBtnLabelText.toLowerCase() == "sold out"){
    customBtn.disabled = true;
    customBtn.classList.add('disabled-custom-btn');
  }
  // else if(defaultBtnLabelText == "Pre-order"){
  //   // customBtn.classList.add('disabled-custom-btn');
  //   //Add Pre order conditions here
  // }
});